import { useState } from 'react';

import { StoreAutoComplete } from 'components/autocompletes';
import { DatePickerYear } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function DreGridFilter() {
    const [filterNrAno, setFilterNrAno] = useState<FilterValuesProps>({
        property: 'nrAno',
        operator: 'eq',
        value: new Date(),
        idProperty: 'year',
        required: 'Selecione o mês/ano para prosseguir.',
    });

    const [filterLoja, setFilterLoja] = useState<FilterValuesProps>({
        property: 'idLoja',
        operator: 'in',
        value: [],
        idProperty: 'idLoja',
        required: 'Loja é obrigatória',
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterNrAno, setter: setFilterNrAno },
                { value: filterLoja, setter: setFilterLoja },
            ]}
        >
            <DatePickerYear
                label="Ano"
                minDate={new Date('2010-01-01')}
                maxDate={new Date()}
                value={filterNrAno.value}
                onChange={(value) => {
                    setFilterNrAno((oldState: FilterValuesProps) => ({ ...oldState, value }));
                }}
                sx={{ flex: 1 }}
            />
            <StoreAutoComplete
                sx={{ flex: 3 }}
                multiple={true}
                value={filterLoja.value}
                onChange={(e, value) => setFilterLoja((oldState: FilterValuesProps) => ({ ...oldState, value }))}
            />
        </Filter>
    );
}
